import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const setupMasks = (el, img, isRM) => {
  const mImg = document.createElement('img');
  const mDiv = document.createElement('div');
  const tDiv = document.createElement('div');
  mImg.src = img.currentSrc;

  const i = (el.dataset.stepImg - 1) % 3;
  mDiv.classList.add(
    'steps__step-mask',
    `steps__step-mask--${i}`,
    'size-100',
    'overflow-hidden',
    'absolute'
  );
  tDiv.classList.add(
    'steps__step-tfrom',
    `steps__step-tfrom--${i}`,
    'size-100',
    'absolute'
  );

  tDiv.appendChild(mImg);
  mDiv.appendChild(tDiv);
  el.appendChild(mDiv);

  if (!isRM) {
    gsap.to(mImg, {
      scale: 1.5,
      rotate: 20,
      ease: 'none',

      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 3
      }
    });
  } else {
    gsap.set(mImg, {
      scale: 1.5,
      rotate: 20
    });
  }
};

const init = (isRM) => {
  const masked = document.querySelectorAll('[data-step-img]');
  masked.forEach((el) => {
    const img = el.querySelector('img');
    if (img.complete && img.naturalHeight !== 0) {
      setupMasks(el, img, isRM);
    } else {
      img.addEventListener('load', () => setupMasks(el, img, isRM));
    }
  });
};

export { init };
